(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/init.js');
"use strict";

var _svs$ticketUtility;
let loadGameloaderHelper;
if ((_svs$ticketUtility = svs.ticketUtility) !== null && _svs$ticketUtility !== void 0 && (_svs$ticketUtility = _svs$ticketUtility.data) !== null && _svs$ticketUtility !== void 0 && _svs$ticketUtility.gameloaderHelperConfig) {
  const {
    url,
    path
  } = svs.ticketUtility.data.gameloaderHelperConfig;
  loadGameloaderHelper = new Promise(resolve => {
    const logger = new svs.core.log.Logger('ticket-utility:game-loader-helper-init');
    const script = document.createElement('script');
    const scriptSrc = "".concat(url).concat(path);
    script.src = scriptSrc;
    script.type = 'text/javascript';
    script.async = true;
    script.onload = () => {
      logger.debug("gameloaderHelper v".concat(gameloaderHelper.version, " loaded from ").concat(scriptSrc, " - overriding local instance"));
      resolve();
    };
    script.onerror = () => {
      logger.warn("Failed to load gameloaderHelper from ".concat(scriptSrc, " - using local instance."));
      resolve();
    };
    document.head.appendChild(script);
  });
} else {
  loadGameloaderHelper = {
    then: cb => {
      cb();
    }
  };
}
setGlobal('svs.ticketgames.ticketUtility.loadGameloaderHelper', loadGameloaderHelper);

 })(window);